import {
  TicketPlus,
  UserRoundCheck,
  CircleCheckBig,
  ClockAlert,
  type LucideIcon,
} from 'lucide-react';
import type { InAppNotificationKind } from '@sd/lib/inAppNotifications';

export type NotificationKindMeta = {
  label: string;
  icon: LucideIcon;
  iconClass: string;
  bubbleClass: string;
  ringClass: string;
};

export const notificationKindMeta: Record<InAppNotificationKind, NotificationKindMeta> = {
  new_ticket: {
    label: 'New Ticket',
    icon: TicketPlus,
    iconClass: 'text-blue-600 dark:text-blue-400',
    bubbleClass: 'bg-blue-50 dark:bg-blue-950/60',
    ringClass: 'ring-blue-200/80 dark:ring-blue-800/60',
  },
  assignment: {
    label: 'Assignment',
    icon: UserRoundCheck,
    iconClass: 'text-emerald-600 dark:text-emerald-400',
    bubbleClass: 'bg-emerald-50 dark:bg-emerald-950/50',
    ringClass: 'ring-emerald-200/80 dark:ring-emerald-800/60',
  },
  status_change: {
    label: 'Status Update',
    icon: CircleCheckBig,
    iconClass: 'text-violet-600 dark:text-violet-400',
    bubbleClass: 'bg-violet-50 dark:bg-violet-950/50',
    ringClass: 'ring-violet-200/80 dark:ring-violet-800/60',
  },
  sla_warning: {
    label: 'SLA Alert',
    icon: ClockAlert,
    iconClass: 'text-amber-600 dark:text-amber-400',
    bubbleClass: 'bg-amber-50 dark:bg-amber-950/50',
    ringClass: 'ring-amber-200/80 dark:ring-amber-800/60',
  },
};

export function getNotificationKindMeta(kind: InAppNotificationKind): NotificationKindMeta {
  return notificationKindMeta[kind] ?? notificationKindMeta.new_ticket;
}
